import { UnitType } from '@exodus/currency'

const name = 'bgold'
const displayName = 'Bitcoin Gold'
const ticker = 'BTG'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#254FB3'
const gradientColors = ['#254FB3', '#2573b3']
const gradientCoords = { x1: '0%', y1: '0%', x2: '100%', y2: '100%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  BTG: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.bitcoingold.org/insight/address/${address}`,
  txUrl: (txId) => `https://explorer.bitcoingold.org/insight/tx/${txId}`,
}
const info = {
  description:
    'Bitcoin Gold is a fork, or split, from the original Bitcoin that aims to “make Bitcoin decentralized again” by making the mining process resistant to expensive and specialized ASIC hardware, allowing everyday users to mine and recreating network effects that Bitcoin once had.',
  reddit: 'https://www.reddit.com/r/BitcoinGoldHQ/',
  twitter: 'https://twitter.com/bitcoingold',
  website: 'https://bitcoingold.org/',
  telegram: 'https://t.me/BitcoinGoldHQ',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
